import React from 'react';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import { ConversionOption } from '.';

interface Props {
  conversionOption: ConversionOption;
  additionalDays: number;
  lostFeatures: string[];
  newFeatures: string[];
}

function DiffFeatures(props: { title: string; features: string[] }) {
  const { title, features } = props;
  if (features.length === 0) {
    return null;
  }
  return (
    <>
      <span>{title}</span>
      <ul tw="list-disc pl-5">
        {features.map((f, idx) => (
          <li key={idx}>{f}</li>
        ))}
      </ul>
    </>
  );
}

export function ConversionOptionDescription(props: Props) {
  const { conversionOption, additionalDays, lostFeatures, newFeatures } = props;
  const isSameFeatures = lostFeatures.length === 0 && newFeatures.length === 0;
  const { t } = useTranslation(['userSettings']);

  return (
    <>
      {t(`userSettings:pricing.licenseActivation.options.${conversionOption}`, {
        additionalDays,
      })}
      <div tw="mt-4">
        {isSameFeatures &&
          t('userSettings:pricing.licenseActivation.sameFeaturesAccess')}
        <DiffFeatures
          title={t('userSettings:pricing.licenseActivation.newFeaturesAccess')}
          features={newFeatures}
        />
        <DiffFeatures
          title={t('userSettings:pricing.licenseActivation.lostFeaturesAccess')}
          features={lostFeatures}
        />
      </div>
    </>
  );
}
